import React from 'react';

import { version } from '../../../../../../package.json';
import bufflLogoWhiteSmall from '../../../../assets/img/buffl-logo-white-small.png';
import bLogoWhiteSmall from '../../../../assets/img/b-logo-white-small.png';

import styles from '../AppBar.module.css';

const onSuccess = history => {
  history.push('/');
};

const backend = localStorage.getItem('backend')
  ? localStorage.getItem('backend')
  : '';

const AppBarLeft = ({
  history,
  isAuthenticated,
  onGoToPortalPage,
  path,
  isFetching,
  appBarProperties,
  onSearchCampaigns
}) => {
  const hasActionButtons =
    appBarProperties &&
    appBarProperties.buttons &&
    appBarProperties.buttons.length > 0;

  const logoPart = (
    <div
      className={
        backend ? `${styles.logoPart} ${styles.backend}` : styles.logoPart
      }
    >
      <img
        src={onGoToPortalPage ? bLogoWhiteSmall : bufflLogoWhiteSmall}
        className={styles.bufflLogoWhiteSmall}
        role="presentation"
        onClick={() => {
          if (isAuthenticated) {
            if (history.location.pathname === '/') {
              onSearchCampaigns('');
            } else {
              onGoToPortalPage(onSuccess, history);
            }
          }
          return false;
        }}
        alt="BUFFL logo"
      />
      <span className={styles.bufflVersion}>v{version}</span>
      {backend ? (
        <span className={styles.bufflVersion}> - {backend}</span>
      ) : null}
    </div>
  );

  if (!isAuthenticated) {
    return (
      <div
        className={`${
          styles.appBarShortLogoContainer
        } app-bar-short-logo-container`}
      >
        {logoPart}
        {appBarProperties && appBarProperties.routeSubtitle && !isFetching ? (
          <span
            className={`${styles.routeSubtitleName} ${
              styles.routeSubtitleNameNotAuthenticated
            } route-subtitle-name ${
              !hasActionButtons ? 'route-subtitle-name-extended' : ''
            }`}
          >
            {appBarProperties.routeSubtitle}
          </span>
        ) : null}
      </div>
    );
  }

  if (path === '/') {
    return (
      <div
        className={`${
          styles.appBarShortLogoContainer
        } app-bar-short-logo-container`}
      >
        {logoPart}
      </div>
    );
  }

  return (
    <div
      className={`${
        styles.appBarShortLogoContainer
      } app-bar-short-logo-container`}
    >
      {logoPart}
      {onGoToPortalPage &&
      !(appBarProperties && appBarProperties.routeTitle) ? (
        <button
          className={`${styles.myCampaignsAction} my-campaigns-action`}
          type="button"
          onClick={() => {
            onGoToPortalPage(onSuccess, history);
            return false;
          }}
        >
          &#x3c; My Surveys
        </button>
      ) : null}
      {appBarProperties && appBarProperties.routeTitle && !isFetching
        ? appBarProperties.routeTitle
        : null}
      {appBarProperties && appBarProperties.routeSubtitle && !isFetching ? (
        <span
          className={`${styles.routeSubtitleName} route-subtitle-name ${
            !hasActionButtons ? 'route-subtitle-name-extended' : ''
          }`}
        >
          / {appBarProperties.routeSubtitle}
        </span>
      ) : null}
    </div>
  );
};

export default AppBarLeft;
